import React, { useState, useEffect } from 'react';
import { FaLinkedin, FaTwitter, FaGithub, FaQuoteLeft } from 'react-icons/fa';
import './PageCss/Team.css';
import tech2 from '../img/akash1.jpg';
import tech3 from '../img/anil.jpg';
import tech4 from '../img/sami.jpg';
import tech5 from '../img/akash.jpg';

const Team = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAutoScrolling, setIsAutoScrolling] = useState(true);
  const teamMembers = [
    {
      id: 1,
      name: "Akash G C",
      role: "CEO & Founder",
      image: tech2,
      quote: "Great ideas are born from bold leadership and relentless passion.",
      social: {
        linkedin: "#",
        twitter: "#",
        github: "#"
      }
    },
    {
      id: 2,
      name: "Anil Regmi",
      role: "Sr. Software Engineer",
      image: tech3,
      quote: "Clean code and clear design pave the way for innovation.",
      social: {
        linkedin: "#",
        twitter: "#",
        github: "#"
      }
    },
    {
      id: 3,
      name: "Samiksha Subedi",
      role: "Admin & HR",
      image: tech4,
      quote: "Empowering people is the foundation of every successful organization.",
      social: {
        linkedin: "#",
        twitter: "#",
        github: "#"
      }
    },
    {
      id: 4,
      name: "Er. Akash G C",
      role: "Sr. Software Engineer",
      image: tech5,
      quote: "Elegance in code comes from a mind that values simplicity.",
      social: {
        linkedin: "#",
        twitter: "#",
        github: "#"
      }
    },
  ];
  

  useEffect(() => {
    let interval;
    if (isAutoScrolling) {
      interval = setInterval(() => {
        setActiveIndex((prev) => (prev + 1) % teamMembers.length);
      }, 5000);
    }
    return () => clearInterval(interval);
  }, [isAutoScrolling, teamMembers.length]);

  const handlePrev = () => {
    setIsAutoScrolling(false);
    setActiveIndex((prev) => (prev - 1 + teamMembers.length) % teamMembers.length);
  };

  const handleNext = () => {
    setIsAutoScrolling(false);
    setActiveIndex((prev) => (prev + 1) % teamMembers.length);
  };

  const handleDotClick = (index) => {
    setIsAutoScrolling(false);
    setActiveIndex(index);
  };

  return (
    <section className="team-section">
      <div className="team-container">
        <div className="team-header">
          <h2>Meet Our Experts</h2>
          <p>Passionate professionals driving innovation and excellence</p>
        </div>

        <div className="team-carousel">
          <button className="carousel-button prev" onClick={handlePrev}>
            <svg viewBox="0 0 24 24">
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
            </svg>
          </button>

          <div className="carousel-track">
            {teamMembers.map((member, index) => (
              <div
                key={member.id}
                className={`team-member ${index === activeIndex ? 'active' : ''}`}
                style={{
                  '--index': index - activeIndex
                }}
              >
                <div className="member-content">
                  <div className="member-image-wrapper">
                    <div className="member-image">
                      <img src={member.image} alt={member.name} />
                    </div>
                    <div className="member-shape"></div>
                  </div>
                  <div className="member-info">
                    <h3>{member.name}</h3>
                    <span className="member-role">{member.role}</span>
                    <div className="member-quote">
                      <FaQuoteLeft className="quote-icon" />
                      <p>{member.quote}</p>
                    </div>
                    <div className="social-links">
                      <a href={member.social.linkedin} target="_blank" rel="noopener noreferrer">
                        <FaLinkedin />
                      </a>
                      <a href={member.social.twitter} target="_blank" rel="noopener noreferrer">
                        <FaTwitter />
                      </a>
                      <a href={member.social.github} target="_blank" rel="noopener noreferrer">
                        <FaGithub />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button className="carousel-button next" onClick={handleNext}>
            <svg viewBox="0 0 24 24">
              <path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z"/>
            </svg>
          </button>
        </div>

        <div className="carousel-dots">
          {teamMembers.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === activeIndex ? 'active' : ''}`}
              onClick={() => handleDotClick(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
